import React from 'react';
import { Heart, Github, Linkedin, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const techStack = [
    'DÉVELOPPEMENT WEB',
    'CYBERSÉCURITÉ',
    'Nouvelles technologies',
    'JAVA',
    'PYTHON',
    'REACT',
    'JavaScript',
    'PHP',
    'MYSQL',
    'ALGORITHMIQUE',
    'C'
  ];

  return (
    <footer className="footer">
      {/* Animated tech marquee */}
      <div className="footer-marquee">
        <div className="marquee-content">
          {[...techStack, ...techStack, ...techStack].map((tech, index) => (
            <React.Fragment key={index}>
              <span className="marquee-text">{tech}</span>
              <span className="marquee-separator">-</span>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            
            {/* --- LE MÊME LOGO QUE LE HEADER --- */}
            <div className="footer-brand">
              <img 
                src="/logoPortfolio.png" 
                alt="Logo Omar Aldroubi" 
                className="footer-custom-logo"
                style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover' }}
              />
              <span className="footer-logo">OMAR ALDROUBI</span>
            </div>
            {/* ---------------------------------- */}
            
            <p className="footer-tagline">
              Futur ingénieur en Informatique. Toujours à la recherche de nouveaux défis techniques pour créer des solutions fiables et sécurisées.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">Navigation</h4>
            <ul className="footer-links">
              <li><a href="#hero">Accueil</a></li>
              <li><a href="#about">À Propos</a></li>
              <li><a href="#filmography">Projets</a></li>
              <li><a href="#skills">Compétences</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">Suivez-moi</h4>
            <div className="footer-social-links">
              <a 
                href="https://github.com/Omar-Aldroubi" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-footer"
              >
                <Github size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/in/omar-aldroubi-b43173291/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-footer"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="mailto:contact@omaraldroubi.fr"
                className="social-link-footer"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Omar Aldroubi. Tous droits réservés.
          </p>
          <div className="footer-made-with">
            <span>Fait avec</span>
            <Heart className="heart-icon" fill="#d4af37" />
            <span>à Caen, France</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;